import { render, staticRenderFns } from "./CheckoutPayments.vue?vue&type=template&id=5162f6c8"
import script from "./CheckoutPayments.vue?vue&type=script&lang=js"
export * from "./CheckoutPayments.vue?vue&type=script&lang=js"
import style0 from "./CheckoutPayments.vue?vue&type=style&index=0&id=5162f6c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports